import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import { withTranslation } from 'react-i18next'
import AttributeSingleValueSelect from '../attribute-single-value-select'

let options = [{ value: '', label: '' }]
for (let i = 0; i <= 24; i++) {
  for (let minute of ['00', '30']) {
    if (i === 24 && minute === '30') {
      continue
    }
    const hour = i > 9 ? i : '0' + i
    let option = Object.freeze({ value: hour + ':' + minute, label: hour + ':' + minute })
    options.push(option)
  }
}

class AttributeTime extends PureComponent {

  render () {
    const blueprint = this.props.blueprint
    blueprint.options = options
    return (
      <AttributeSingleValueSelect {...this.props}/>
    )
  }
}

AttributeTime.defaultProps = {}

AttributeTime.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  data: PropTypes.object,
  collapsed: PropTypes.bool.isRequired,
  putAttribute: PropTypes.func.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
  putValidationStatus: PropTypes.func.isRequired,
}
export default withTranslation()(AttributeTime)
